"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _PhrasingLoading = _interopRequireDefault(require("./PhrasingLoading"));
var _withExperimentalExport = require("../../tools/component/ExperimentalInformation/withExperimentalExport");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var _default = exports["default"] = (0, _withExperimentalExport.withExperimentalExport)(_PhrasingLoading["default"], {
  name: 'Phrasing Loading',
  initDate: '27/06/2023',
  endDate: '',
  owner: {
    developer: 'cynthia.costa',
    team: 'FS Buyer Conversion'
  },
  docLink: 'https://cozy-web-storybook.quintoandar.com.br/?path=/docs/experimental-phrasingloading-1-code--page'
});